"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const IconContainer_1 = __importStar(require("../IconContainer"));
const StyledPathOne = styled_components_1.default.path `
  fill: ${({ theme }) => theme.palette.red[50]};
`;
const StyledPathTwo = styled_components_1.default.path `
  fill: ${({ theme }) => theme.palette.orange[30]};
`;
const StyledPathThree = styled_components_1.default.path `
  fill: ${({ theme }) => theme.palette.teal[30]};
`;
const StyledPathFour = styled_components_1.default.path `
  fill: ${({ theme }) => theme.palette.primary.main};
`;
const AppIcon = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, ...rest }) => ((0, jsx_runtime_1.jsxs)("svg", { fill: "none", height: size, viewBox: "0 0 24 24", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: [(0, jsx_runtime_1.jsx)(StyledPathOne, { color: rest.color, d: "M10.542 10.532V6.26A4.275 4.275 0 006.272 2 4.275 4.275 0 002 6.26v3.085a1.2 1.2 0 001.199 1.2h7.343v-.013z" }), (0, jsx_runtime_1.jsx)(StyledPathTwo, { color: rest.color, d: "M13.465 13.455h4.271a4.275 4.275 0 014.259 4.273A4.275 4.275 0 0117.736 22h-3.085a1.2 1.2 0 01-1.199-1.2v-7.345h.013z" }), (0, jsx_runtime_1.jsx)(StyledPathThree, { color: rest.color, d: "M5.447 21.9a4.274 4.274 0 005.02-5.022c-.324-1.661-1.686-3.035-3.347-3.348a4.274 4.274 0 00-5.02 5.022A4.241 4.241 0 005.447 21.9z" }), (0, jsx_runtime_1.jsx)(StyledPathFour, { color: rest.color, d: "M16.9 10.457a4.274 4.274 0 005.02-5.022c-.313-1.661-1.686-3.035-3.347-3.348a4.274 4.274 0 00-5.02 5.022c.311 1.662 1.673 3.023 3.346 3.348z" })] }));
exports.default = (0, IconContainer_1.default)(AppIcon);
//# sourceMappingURL=index.js.map